import { Button } from '@akin-home/buttons/native';
import React, { useState } from 'react';
import { useUpdateScreenChatContext } from '../chat/hooks';
import { useUpdateChatState } from '../chat/hooks/useUpdateChatState';
import FullScreenLoader from '../components/FullScreenLoader';
import { DeveloperScreenInfo } from '../developer/components/DeveloperScreenInfo/DeveloperScreenInfo';
import { MainDrawerScreenProps } from '../navigation/MainDrawerNavigator';
import { NewMealPlanScreen } from '../recipes/components/NewMealPlanScreen/NewMealPlanScreen';
import { useGetStateVariable } from '../state_variables';
import { useMealsInfoVideo } from '../videos/hooks/info_video_hooks';
import { SectionIntroScreen } from './SectionIntroScreen';

const MealsScreen = (props: MainDrawerScreenProps<'Meals'>) => {
  const { data, isLoading: isLoadingStateVar } = useGetStateVariable(
    'Screen_meals_view_count'
  );

  const [continue_pressed, setContinuePressed] = useState(false);

  const update = useUpdateChatState();
  useUpdateScreenChatContext();

  const { data: info_video, isLoading } = useMealsInfoVideo();

  const onPressContinueFromSplashScreen = () => {
    update([
      {
        var_name: 'Screen_meals_view_count',
        operator: '+=',
        value: '1',
        value_type: 'primitive',
      },
    ]);

    setContinuePressed(true);
  };

  if (isLoadingStateVar || isLoading) {
    return <FullScreenLoader />;
  }

  if (
    (!data?.value || data.value === '0') &&
    !continue_pressed &&
    info_video?.value?.length
  )
    return (
      <SectionIntroScreen
        screen_title="Meals"
        video_title="Watch the video and learn about meal plans"
        source={{ drive_id: info_video.value }}
        action_button={
          <Button icon="plus" onPress={onPressContinueFromSplashScreen}>
            Continue to your meal plan
          </Button>
        }
      />
    );

  return (
    <>
      <NewMealPlanScreen {...props} />
      <DeveloperScreenInfo />
    </>
  );
};

export default MealsScreen;
